"use client";

import { useResponsive } from "@dafiti/closet-ui/hooks";

import { useInfiniteWishlistResults } from "./useInfiniteWishlistResults.hook";
import { usePaginatedWishlistResults } from "./usePaginatedWishlistResults.hook";

type Props = {
  page: number;
  userAgent?: string | null;
};

export function useWishlistResults({ page, userAgent }: Props) {
  const { isMobile } = useResponsive({ userAgent });
  const isMobileResolved = isMobile ?? false;

  const paginated = usePaginatedWishlistResults({
    page,
    enabled: !isMobileResolved,
  });
  const infinite = useInfiniteWishlistResults({ enabled: isMobileResolved });

  return isMobileResolved ? infinite : paginated;
}
